import { TenantEntity } from '../TenantEntity'
import { getVoyagesByVesselId } from '@/api/vessel'

export class Voyage extends TenantEntity {
  // 根据vesselId分组的航次缓存
  static _voyageCache = []
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get voyageId() {
    return this._data.voyageId
  }
  set voyageId(voyageId) {
    this._data.voyageId = voyageId
  }
  get vesselId() {
    return this._data.vesselId
  }
  set vesselId(vesselId) {
    this._data.vesselId = vesselId
  }
  get voyageNo() {
    return this._data.voyageNo
  }
  set voyageNo(voyageNo) {
    this._data.voyageNo = voyageNo
  }
  get voyageCode() {
    return this._data.voyageCode
  }
  set voyageCode(voyageCode) {
    this._data.voyageCode = voyageCode
  }
  get ediVoyageNo() {
    return this._data.ediVoyageNo
  }
  set ediVoyageNo(ediVoyageNo) {
    this._data.ediVoyageNo = ediVoyageNo
  }
  get externalImport() {
    return this._data.externalImport
  }
  set externalImport(externalImport) {
    this._data.externalImport = externalImport
  }
  // 获取航次列表(根据船名ID)
  static async getVoyage(vesselId) {
    return await getVoyagesByVesselId({ vesselId }).then(res => res.data)
  }
}
